import { render, staticRenderFns } from "./Error50x.vue?vue&type=template&id=3fa2cc5c&scoped=true"
import script from "./Error50x.vue?vue&type=script&lang=js"
export * from "./Error50x.vue?vue&type=script&lang=js"
import style0 from "./Error50x.vue?vue&type=style&index=0&id=3fa2cc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2cc5c",
  null
  
)

export default component.exports